import React from 'react';
import styled from 'styled-components';
import Window from '../Window';

const TextEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fa;
`;

const EditorContent = styled.div`
  flex: 1;
  padding: 20px;
  background: white;
  margin: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  overflow-y: auto;
`;

const TextEditorApp = ({ ...windowProps }) => {
  const aboutText =`Hi! I'm Aviral Malik, a passionate Software Developer with expertise in full-stack development and emerging technologies. I'm currently pursuing my Bachelor of Technology in Information Technology at Manipal Institute of Technology, Manipal.

With a strong foundation in programming languages like Python, C#, Java, and JavaScript, I specialize in building scalable web applications and microservices. My experience includes developing real-time chat applications, full-stack platforms, and optimizing database performance.

I've worked as a Software Developer Intern at NDTV, where I developed microservices and improved system efficiency by 50%. I'm also experienced with cloud technologies like AWS, Docker, and CI/CD pipelines.

My goal is to create innovative solutions that solve real-world problems while continuously learning and adapting to new technologies.`;

  return (
    <Window {...windowProps} size={{ width: 500, height: 400 }}>
      <TextEditorContainer>
        <EditorContent>
          {aboutText}
        </EditorContent>
      </TextEditorContainer>
    </Window>
  );
};

export default TextEditorApp;
